import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { FlexContainer } from "../../../constants/assets/containers";
import { connect } from "react-redux";
import moment from "moment";
import {
  filterObj,
  isObjectAllEntriesPresent,
  isObjectStateEmpty,
  isValNull,
  removeEmptyVals,
} from "../../../utils";
import { bindActionCreators } from "redux";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { setEntityList } from "../../../store/actions/CapacityChange";
import { setActiveFilters } from "../../../store/actions/CapacityChange";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

export const entityTypeList = [{ entity_type: "ZONE", id: 0 }];

const CreateFilters = ({
  getSlotsList,
  carrierList,
  userAttributes,
  activeFilters,
  setEntityList,
  entityList,
  isLoading,
  setActiveFilters,
  setEntityId,
}) => {
  const [initialState, setInitialState] = useState({
    entity: {
      zone_id: "",
      zone_name: "",
    },
    city: {
      id: "",
      name: "",
      zones: [],
    },
    date: "",
    entity_type: "",
    carrier_type: "",
  });
  const [cityList, setCityList] = useState([]);
  const [currentDate, setCurrentDate] = useState();

  const getValue = (key, val) => {
    if (key === "city") {
      const activeCity = cityList.find((item) => item.id == val);
      return activeCity ? activeCity.name : "";
    } else if (key === "entity") {
      const activeEntityName = entityList.find((item) => item.zone_id === val);
      return activeEntityName ? activeEntityName.zone_name : "";
    } else if (key === "entity_type") {
      const activeEntityType = entityTypeList.find((item) => item.id === val);
      return activeEntityType ? activeEntityType.entity_type : "";
    } else if (key === "carrier") {
      const activeCarrier = carrierList.find((item) => item.id === val);
      return activeCarrier ? activeCarrier.carrier_type : "";
    } else {
      return val;
    }
  };

  const checkIfButtonDisabled = (type) => {
    if (type === "submit") {
      return !isObjectAllEntriesPresent(
        filterObj(initialState, [
          "entity_type",
          "entity",
          "carrier_type",
          "date",
          "city",
        ])
      );
    } else {
      return isObjectStateEmpty(initialState);
    }
  };

  const handleFilterChange = (key, value) => {
    const values = { ...initialState };
    values[key] = value;
    if (key == "city") {
      cityList.map((city) => {
        if (city.id === value?.id) {
          setEntityList(city.zones);
        }
      });
      values["entity"] = {};
    }
    setInitialState(values);
    if (Object.keys(values).length > 0) {
      setActiveFilters(values);
    }
  };

  useEffect(() => {
    setCurrentDate(new Date().toISOString().substring(0, 10));
    setInitialState({
      city: !isValNull(activeFilters.city)
        ? activeFilters.city
        : {
            id: "",
            name: "",
            zones: [],
          },
      entity: !isValNull(activeFilters.entity)
        ? activeFilters.entity
        : {
            zone_id: "",
            zone_name: "",
          },
      carrier_type: !isValNull(activeFilters.carrier_type)
        ? activeFilters.carrier_type
        : "",
      date: !isValNull(activeFilters.date)
        ? moment(activeFilters.date).format("YYYY-MM-DD")
        : "",
      entity_type: !isValNull(activeFilters.entity_type)
        ? activeFilters.entity_type
        : "",
    });
  }, []);

  useEffect(() => {
    const cities = [];
    (userAttributes || []).forEach((element) => {
      cities.push({
        id: element.city_id,
        name: element.city_name,
        zones: element.zones,
      });
    });
    setCityList(cities);
  }, [userAttributes]);

  useEffect(() => {
    const states = { ...initialState };
    if (isValNull(activeFilters.city)) {
      if (cityList && cityList.length == 1) {
        states.city = cityList[0];
        setEntityList(cityList[0].zones);
      }
    }
    if (isValNull(activeFilters.entity_type)) {
      states.entity_type =
        entityTypeList.length == 1 ? entityTypeList[0].id : "";
    }
    if (isValNull(activeFilters)) {
      setInitialState(states);
    }
  }, [cityList, entityTypeList]);

  const handleFiltersSubmit = (e) => {
    e.preventDefault();
    const newState = removeEmptyVals(initialState);
    if (newState["date"]) {
      newState["date"] = moment(newState["date"]);
    }
    newState["entity_id"] = initialState.entity.zone_id;
    delete newState.entity;
    getSlotsList(newState, "removeCityId").then((res) => {
      setEntityId(newState.entity_id);
    });
  };

  return (
    <React.Fragment>
      <FlexContainer align="flex-start" style={{ marginTop: "10px" }}>
        <Autocomplete
          style={{ flexGrow: 1 }}
          value={initialState.city}
          onChange={(event, newValue) => {
            handleFilterChange("city", newValue);
          }}
          data-testid="city"
          id="setCity"
          options={cityList}
          getOptionLabel={(option) => option.name}
          closeIcon={false}
          autoComplete
          sx={{ width: 500 }}
          renderInput={(params) => (
            <TextField {...params} label="City" variant="outlined" />
          )}
        />
        <PaginatedReactDropdown
          style={{ flexGrow: 1 }}
          key={`entityType${initialState.entity_type}`}
          options={entityTypeList}
          labelKey="entity_type"
          valueKey="id"
          id={`entityType${initialState.entity_type}`}
          optionsBoxId="entity_type_options_box"
          value={getValue("entity_type", initialState.entity_type)}
          handleChange={handleFilterChange}
          keyToChange={"entity_type"}
          placeholder="Entity Type"
          width={400}
        />
        <Autocomplete
          style={{ flexGrow: 1 }}
          value={initialState.entity}
          disabled={isValNull(initialState.city?.id)}
          onChange={(event, newValue) => {
            handleFilterChange("entity", newValue);
          }}
          id={`entityName${initialState.entity_id}`}
          options={entityList}
          getOptionLabel={(option) => option.zone_name}
          closeIcon={false}
          autoComplete
          renderInput={(params) => (
            <TextField {...params} label="Entity Name" variant="outlined" />
          )}
          clear
        />
        <PaginatedReactDropdown
          options={carrierList}
          labelKey="carrier_type"
          valueKey="id"
          id={`carrierName${initialState.carrier_type}`}
          key={`carrierName${initialState.carrier_type}`}
          optionsBoxId="carrier_type_options_box"
          value={getValue("carrier", initialState.carrier_type)}
          handleChange={handleFilterChange}
          keyToChange={"carrier_type"}
          placeholder="Carrier"
          width={400}
        />
        <Input
          key={"requestedDate"}
          id="sushi-input"
          value={
            (initialState.date &&
              moment(initialState.date).format("YYYY-MM-DD")) ||
            " "
          }
          label="Date"
          type="date"
          onChange={(e) => handleFilterChange("date", e)}
          min={currentDate}
        />
        <Button
          disabled={checkIfButtonDisabled("submit")}
          data-testid="SlotsFiltersApply"
          type="submit"
          className="sushi-btn mr-10"
          onClick={handleFiltersSubmit}
          loading={isLoading}
        >
          Get Slots
        </Button>
      </FlexContainer>
    </React.Fragment>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setEntityList: bindActionCreators(setEntityList, dispatch),
    setActiveFilters: bindActionCreators(setActiveFilters, dispatch),
  };
}

function mapStateToProps(state) {
  const { User, CapacityChange } = state;
  return {
    activeFilters: CapacityChange.activeFilters,
    isLoading: User.isLoading,
    entityList: CapacityChange.entityList,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateFilters);
